import React from "react";
import { Seo } from "@/components/Seo";
import { useLead } from "@/context/LeadContext";
import { useBooking } from "@/context/BookingContext";
import { Hero } from "@/components/landing/Hero";
import { SplitNav } from "@/components/landing/SplitNav";
import { ProSection } from "@/components/landing/ProSection";
import { PreventiveCare } from "@/components/landing/PreventiveCare";
import { Retention } from "@/components/landing/Retention";
import { BeforeAfter } from "@/components/landing/BeforeAfter";
import { Testimonials } from "@/components/landing/Testimonials";

export default function Home() {
  const { openForm } = useLead();
  const { openBooking } = useBooking();
  return (
    <>
      <Seo
        title="MARTIN NETTOYAGE — Auto Detailing & Nettoyage Habitat | Belfort, Montbéliard, Héricourt"
        description="Detailing auto, pressing & nettoyage de sièges, canapés et matelas par injection-extraction à Belfort, Montbéliard, Héricourt. Résultat pro garanti. Réservez en ligne."
        path="/"
      />
      <Hero onReserve={openForm} onBook={openBooking} />
      <SplitNav onReserve={openForm} onBook={openBooking} />
      <Testimonials />
      <BeforeAfter />
      <ProSection onReserve={openForm} />
      <PreventiveCare onReserve={openForm} />
      <Retention onReserve={openForm} />
    </>
  );
}
